import { useLink } from '../../../shared/link';
import { useEnv } from '../../../shared/utils/env';
import { extractAgencyFromUrl } from '../../../shared/utils/url';

const env = useEnv({ shortened: true });
const agency = extractAgencyFromUrl(window.location.hostname) || undefined;

export const basicRedirect = (product, path = '') => {
  const link = useLink({
    product,
    env,
    agency,
  });
  window.location.href = `${link}${path}`;
};
